import { render, staticRenderFns } from "./new_product.vue?vue&type=template&id=565ce4d0&scoped=true"
import script from "./new_product.vue?vue&type=script&lang=js"
export * from "./new_product.vue?vue&type=script&lang=js"
import style0 from "./new_product.vue?vue&type=style&index=0&id=565ce4d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ce4d0",
  null
  
)

export default component.exports